module.exports = __webpack_public_path__ + "static/media/share_image.e178b455.png";